<template>
  <div class="news-container">
    <div class="main-title" style="border: none">
      <span class="text">新闻公告</span>
      <span class="eng">News</span>
    </div>
    <div class="news-list">
      <div 
        target="_blank"
        v-for=" news in newsList"
        :key="news.id"
        @click="showNewsDetail(news.id)"
        class="news-card clearfix"
      >
        <div class="news-time">{{ $utils.formatDate(news.publish_time, 'YYYY-MM-DD') }}</div>
        <div class="news-name" :title="news.name">{{ news.name }}</div>
      </div>
    </div>
    <div
      class="more-btn"
      onclick="window.open('/swh5/HEU/notice/notice.html')"
    >
      <span class="btn-text">查看全部</span>
      <i class="iconfont icongengduo"></i>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.getNewsList();
  },
  data() {
    return { newsList: [] };
  },
  methods: {
    async getNewsList() {
     const res = await this.$http.HEU.getNewsList({
       '_pageable.page': 0,
       '_pageable.size': 4
     })
     console.log(res);
     this.newsList = res.content || []
    },
    // 点击卡片进去详情页
    showNewsDetail(id) {
      window.location.href = `/swh5/HEU/notice/noticeDetail.html?id=${id}`
    }
  },
};
</script>
<style lang="scss" scoped>
.btn-text {
  margin-right: 8px;
}
.news-list .news-card .news-name {
  &:hover {
    color: #0c3a93;
  }
}
</style>